var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 387",
    width: "15px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M79.63 80.57C118.95 77.72 162.27 100.64 185.48 136.12C189.2 131.77 192.57 127.49 196.33 123.47C219.62 98.53 262.92 102.84 282.55 130.09C295.59 148.19 302.28 168.37 310.49 188.11C316.17 201.75 321.48 215.67 329.2 228.45C336.77 240.99 349.8 240.96 357.47 228.45C363.89 217.96 367.36 204.99 369.7 193.35C373.24 175.78 376.87 159.22 386.3 143.16C398.04 123.18 413.96 106.12 436.67 94.33C454.74 84.95 473.85 79.37 495.69 80.09C495.69 93.27 495.69 105.98 495.69 118.68C445.69 121.04 414.66 160.01 415.84 194.73C417 228.78 447.76 265.37 495.7 266.99C495.7 279.5 495.7 292.03 495.7 304.61C466.64 310.76 415.09 288.2 391.82 251.2C388.52 254.84 379.57 275.73 345.85 278.65C311.64 281.22 293.68 264.04 282.68 239.42C272.82 217.36 265.09 194.6 256.18 172.22C254.24 167.33 251.85 162.45 248.74 158.06C240.67 146.67 226.74 148.92 217.32 162.24C207.29 176.43 204.52 192.23 201.78 208.15C197.61 232.3 186.61 253.53 167.09 271.54C150.36 286.96 131.12 298.54 107.17 303.4C98.56 305.15 89.58 305.56 79.9 306.68C79.9 292.86 79.9 280.15 79.9 266.79C103.33 267.15 122.76 258.45 137.69 243.48C154.23 226.91 162.7 207.18 159.71 184.89C155.76 155.37 128.25 121.12 79.63 118.65C79.63 106.15 79.63 93.62 79.63 80.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M575.47 386.45L-0.11 386.45L-0.11 0.44L575.47 0.44L575.47 386.45ZM39.67 40.22L39.67 346.67L535.69 346.67L535.69 40.22L39.67 40.22Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoson);
export default __webpack_public_path__ + "static/media/boson.25b853f69afaf941ce7d51ab295d4043.svg";
export { ForwardRef as ReactComponent };